module.exports = __webpack_public_path__ + "img/hz.41b7dcef.png";